import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Table } from "core/table/Table";
import { Typography } from "core/typography/Typography";
import LightModal from "components/modal/LightModal";
import React, { useContext, useState } from "react";
import {
  displayProspections,
  formatUserClient,
  header,
  headerClient,
  headerProspection,
} from "utils/clientHelper";
import InfoContext from "pages/InfoContext";
import { useUserContext } from "api/user/UserProvider";
import DeleteModal from "components/modal/DeleteModal";
import { ROLE_ADMIN, ROLE_ASSOC } from "access-roles/roles";
import { useLocalStorage } from "react-use";
import { useProspectionContext } from "api/directory/prospection/ProspectionProvider";
import UpdateProspectionModal from "components/modal/UpdateProspectionModal";

const ClientsStaff = ({
  userClientList,
  lang,
  userScope,
  prospectionList,
  staffBySlug,
}) => {
  const [openProspectionModal, setOpenProspectionModal] = useState(false);
  const [openTrafficModal, setOpenTrafficModal] = useState(false);
  const [trafficLightValue, setTrafficLightValue] = useState("");
  const [trafficLightNewValue, setTrafficLightNewValue] = useState("");
  const [openReleaseModal, setOpenReleaseModal] = useState(false);
  const [clientId, setClientId] = useState(0);
  const [clientName, setClientName] = useState("");
  const {
    patchClientTrafficLight,
    setRefresh,
    releaseClient,
    sectorList,
    updateProspectionSector,
    updateProspectionTrafficLight,
  } = useContext(InfoContext);
  const { releaseProspection } = useProspectionContext();
  const { connectedUser, userRoleList } = useUserContext();
  const userAccess = [ROLE_ADMIN, ROLE_ASSOC].some((role) =>
    userRoleList?.includes(role)
  );
  const [isUserAuthorized] = useState(userAccess);
  const [releaseFunction, setReleaseFunction] = useState(() => () => {});
  const [prospectionData, setProspectionData] = useState({});
  const [clientCreationData, setClientCreationData] = useLocalStorage(
    "clientCreationData",
    {}
  );

  const onValidateTrafficLightUpdate = ({ client_id, traffic_light_value }) => {
    connectedUser &&
      patchClientTrafficLight({
        client_id,
        traffic_light_value,
        manager_id: connectedUser?.id,
      });
    setOpenTrafficModal(false);
    setRefresh(true);
  };

  return (
    <>
      <UpdateProspectionModal
        open={openProspectionModal}
        onClose={() => setOpenProspectionModal(false)}
        sectorList={sectorList}
        prospectionData={prospectionData}
        updateProspectionSector={updateProspectionSector}
        updateProspectionTrafficLight={updateProspectionTrafficLight}
        connectedUser={connectedUser}
      />
      <DeleteModal
        open={openReleaseModal}
        onClose={() => {
          setClientName("");
          setClientId(0);
          setOpenReleaseModal(false);
        }}
        onValidate={() => {
          releaseFunction();
          setOpenReleaseModal(false);
          setReleaseFunction(() => () => {});
          return setRefresh(true);
        }}
        messageId="release_client"
        validationMessages={{
          title: "release_validation",
          message: "release_client_validation",
          client_name: clientName,
        }}
      />
      <LightModal
        open={openTrafficModal}
        onClose={() => setOpenTrafficModal(false)}
        onValidate={() =>
          onValidateTrafficLightUpdate({
            client_id: clientId,
            traffic_light_value: trafficLightNewValue,
          })
        }
        prospectedClients={prospectionList}
        setTrafficLightNewValue={setTrafficLightNewValue}
        defaultValue={trafficLightValue}
      />
      <div className="section">
        <Typography
          className="title-3 violet text-uppercase"
          type="h2"
          label={<FormattedMessage id="clients" defaultMessage="Clients" />}
        />
        <div>
          <Table
            id="client"
            header={headerClient({
              type: "client",
              key: "mission_count",
              value: (
                <FormattedMessage
                  id="billed_number"
                  defaultMessage="Nombre de facturés"
                />
              ),
              icon: "user",
              manager_id: connectedUser?.id,
              id: staffBySlug?.id,
            })}
            content={formatUserClient({
              releaseClient,
              setReleaseFunction,
              userClientList,
              lang,
              userScope,
              setTrafficLightValue,
              setClientId,
              setOpenTrafficModal,
              setOpenReleaseModal,
              setClientName,
              manager_id: connectedUser?.id,
              id: staffBySlug?.id,
            })}
          />
        </div>
      </div>
      <div className="section">
        <Typography
          className="title-3 violet text-uppercase"
          type="h2"
          label={
            <FormattedMessage id="surveys" defaultMessage="Prospections" />
          }
        />
        <div>
          <Table
            id="prospections"
            header={headerProspection({
              isUserAuthorized,
              manager_id: connectedUser?.id,
              id: staffBySlug?.id,
              prospValues: {
                addKey: "create_client",
                addValue: (
                  <FormattedMessage
                    id="create_client"
                    defaultMessage="Créer client"
                  />
                ),
                addIcon: "add",
                releasePropsKey: "release_client",
                modifyIcon: "lightupdate",
              },
            })}
            content={
              prospectionList?.length > 0 &&
              displayProspections({
                setProspectionData,
                setOpenProspectionModal,
                setClientCreationData,
                lang,
                prospectionList,
                setOpenReleaseModal,
                isUserAuthorized,
                setClientName,
                userScope,
                setClientId,
                setReleaseFunction,
                releaseProspection,
                manager_id: connectedUser?.id,
                id: staffBySlug?.id,
              })
            }
          />
        </div>
      </div>
    </>
  );
};

ClientsStaff.propTypes = {
  readOnly: PropTypes.bool,
  userClientList: PropTypes.array,
  lang: PropTypes.string,
  userScope: PropTypes.string,
  prospectionList: PropTypes.array,
  staffBySlug: PropTypes.object,
};

ClientsStaff.defaultProps = {
  readOnly: false,
};

export default ClientsStaff;
